<div class="activity-filters">
  <div class="activity-filters-row">
    <app-date-time-picker
      class="filters-date-time-picker"
      (dateOnSelection)="fromDateSelected($event)"
      label="tableActionsAndFilters.timestampSinceDate"
      [startingValue]="pageFilters.fromDate.getFilterValue()"
      [newValueTriggered$]="fromDateNewValue"
      [minDate]="minDate"
      [maxDate]="pageFilters.toDate.getFilterValue()"
    >
    </app-date-time-picker>
    <app-date-time-picker
      class="filters-date-time-picker"
      (dateOnSelection)="toDateSelected($event)"
      label="tableActionsAndFilters.timestampUntilDate"
      [startingValue]="pageFilters.toDate.getFilterValue()"
      [newValueTriggered$]="toDateNewValue"
      [minDate]="pageFilters.fromDate.getFilterValue()"
    >
    </app-date-time-picker>
  </div>
  <app-view-filters-multi-select [pageFilters]="pageFilters"></app-view-filters-multi-select>
</div>
